export default __webpack_public_path__ + "static/media/valley12.48fbfd7a.png";